import React, { Component, Fragment } from 'react';
import FormCard from './FormCard';
import ModalDialog from '../Common/ModalDialog';
import { Button } from 'react-bootstrap';
import PeriodicFormCard from './PeriodicFormCard';


export class FormList extends Component {


    state = { deleteModalVisible: false, addModalVisible:false, selectedItem: null };
    render() {
        let renderList;
        if (this.props.forms.length > 0) 
            renderList =  this.props.forms.map(item =>
                                        this.renderProperCard(item))        
        else
            renderList = <h2 className="form-empty-list">There are currently no documents in the system</h2>

        return (
            <>
                <div className="form-cards-area">
                        {renderList}
                        <ModalDialog show={this.state.addModalVisible} onHide={()=>this.setState({addModalVisible:false})}
                                title={this.state.selectedItem && "Add " + this.state.selectedItem.name +" form"}

                                footer={
                                    <>
                                        <Button variant="secondary" onClick={() => this.setState({ addModalVisible: false })}>
                                        Close
                                        </Button>
                                        <Button variant="primary" onClick={() => this.setState({ addModalVisible: false })}>
                                            Save Changes
                                        </Button>
                                    </>}                
                        
                        >
                        </ModalDialog>
                </div>
            </>
        )
    }

    renderProperCard=(item)=>{
        {
            if(item.periodicity)
                return <PeriodicFormCard
                            instances={item.instanceList}
                            history={this.props.history}
                            handleRefresh={() => this.props.handleRefresh()}
                            name = {item.formName}
                            showAddModal = {()=>this.showAddModal(item)}
                            >
                        </PeriodicFormCard>                    
            else
            return <FormCard
                        instances={item.instanceList}
                        history={this.props.history}
                        handleRefresh={() => this.props.handleRefresh()}
                        name = {item.formName}
                    >
                    </FormCard>   
        }
    }

    showAddModal=(item)=>{
        
            this.setState({selectedItem:item, addModalVisible:true})
    }



}



export default FormList
